import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TreeCard from "../../../../../../atoms/ActiveLearning/TreeCard";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconAdd } from "../../../../../../assets/images/ActiveLearning/icon_add.svg";
import hintImage10 from "../../../../../../assets/images/ActiveLearning/hint/img_10.webp";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 1);
    if (q) return q;
  }, [props.issue]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          ヒントを参考に、設定した「課題」を解決するためのアイデアを考えてみよう。
          <br />
          実現の可能性は気にせずに、まずは自分が「面白そう」「ワクワクする」と感じるアイデアをいくつか考えよう。
        </p>
      </div>
      {question && (
        <div className={styles.question}>
          <div className={styles.tree}>
            <TreeCard title={"課題"} text={"回答データがありません。"} />
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>アイデア案</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>アイデア案</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>アイデア案</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
            </ul>
            <div className={styles.buttonWrapper}>
              <Button width={"150px"} height={"37px"} fontSize={"14px"}>
                <IconAdd />
                項目を追加する
              </Button>
            </div>
          </div>
        </div>
      )}
      <img src={hintImage10} alt="解決のアイデアを考えるためのヒント" />
    </div>
  );
};
export default Issue1Material;
